var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconPlug = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M7.5 3.75H10.65C12.207 3.75 13.5 4.905 13.5 6.375V7.5H16.5C19.4145 7.5 21 9.0855 21 12C21 14.9145 19.4145 16.5 16.5 16.5H14.25C12.1643 16.5 11.25 17.4143 11.25 19.5V21C11.25 21.414 10.914 21.75 10.5 21.75C10.086 21.75 9.75 21.414 9.75 21V19.5C9.75 16.5855 11.3355 15 14.25 15H16.5C18.5857 15 19.5 14.0857 19.5 12C19.5 9.91425 18.5857 9 16.5 9H13.5V10.125C13.5 11.595 12.207 12.75 10.65 12.75H7.5C7.086 12.75 6.75 12.414 6.75 12V10.5H3.75C3.336 10.5 3 10.164 3 9.75C3 9.336 3.336 9 3.75 9H6.75V7.5H3.75C3.336 7.5 3 7.164 3 6.75C3 6.336 3.336 6 3.75 6H6.75V4.5C6.75 4.086 7.086 3.75 7.5 3.75ZM8.25 11.25H10.65C11.4135 11.25 12 10.7265 12 10.125V6.375C12 5.7735 11.4135 5.25 10.65 5.25H8.25V11.25Z", fill: "black" }))),
        alt: 'Plug',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconPlug;
//# sourceMappingURL=index.js.map